import { render, staticRenderFns } from "./KioskStart.vue?vue&type=template&id=788c4bb6&"
import script from "./KioskStart.vue?vue&type=script&lang=js&"
export * from "./KioskStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports